<template>
  <div class="order_list_container">

    <mt-loadmore :top-method="loadTop" ref="loadmore">
      <pagination v-if="list.length" :data="list" @pagination="loadMore">
        <template slot-scope="scope">
          <order-item v-for="(order, index) in scope.data" :key="index" :order="order" @del="del(index)"/>
        </template>
      </pagination>

      <div v-else class="empty">
        您还没有订单哦～
      </div>
    </mt-loadmore>

  </div>
</template>

<script>
import pagination from '@/components/common/pagination.vue'
import orderItem from '@/views/order/components/orderItem.vue'
import { getOrderList } from '@/api/order'
import { Indicator } from 'mint-ui'

export default {
  name: 'order-list-all',
  props: ['status'],
  data () {
    return {
      loading: false,
      hasMore: true,
      list: [],
      listQuery: {
        page: 1,
        limit: 8
      }
    }
  },
  components: {
    pagination,
    orderItem
  },
  created () {
    this.getOrderList()
  },
  methods: {
    async getOrderList () {
      this.loading = true
      if (this.status) {
        this.listQuery.status = this.status
      }
      let response = await getOrderList(this.listQuery)

      if (this.listQuery.page === 1) {
        this.list = response.data.results
      } else {
        this.list = this.list.concat(response.data.results)
      }

      if (this.list.length >= response.data.count) {
        this.hasMore = false
      }

      this.loading = false
    },
    del (index) {
      this.list.splice(index, 1)
    },
    async loadTop () {
      this.listQuery.page = 1
      this.loading = false
      this.hasMore = true
      await this.getOrderList()

      this.$refs.loadmore.onTopLoaded()
    },
    async loadMore () {
      if (this.loading || !this.hasMore) return false

      Indicator.open({ spinnerType: 'fading-circle' })
      this.listQuery.page += 1
      await this.getOrderList()
      Indicator.close()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .empty {
    height: rem(200);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
  }
</style>
